const CONJUGE = 'Cônjuge';
const EX_CONJUGE = 'Ex-cônjuge';
const CONVIVENTE = 'Convivente';
const FILHO = 'Filho(a)';
const FILHO_ESPECIAL = 'Filho(a) especial';
const FILHO_UNIVERSITARIO = 'Filho(a) universitário(a)';
const ENTEADO = 'Enteado(a)';
const PAI = 'Pai';
const MAE = 'Mãe';
const MENOR_TUTELA = 'Menor sob tutela';

const parentescosGerais = [
  CONJUGE,
  EX_CONJUGE,
  CONVIVENTE,
  FILHO,
  FILHO_ESPECIAL,
  MENOR_TUTELA,
  ENTEADO,
  PAI,
  MAE,
];

const parentescosSemFE = parentescosGerais.filter(
  (parentesco) => parentesco !== FILHO_ESPECIAL
);

const parentescosBeneficiariosRCM = parentescosSemFE;
parentescosBeneficiariosRCM.push(MENOR_TUTELA);

export const parentesco = {
  constants: {
    CONJUGE,
    EX_CONJUGE,
    CONVIVENTE,
    FILHO,
    FILHO_ESPECIAL,
    FILHO_UNIVERSITARIO,
    ENTEADO,
    PAI,
    MAE,
    MENOR_TUTELA,
  },
  options: {
    parentescosGerais,
    parentescosSemFE,
    parentescosBeneficiariosRCM,
  },
};
